import api from '../../../api';
import { finish, error } from '../../../modules/permissions/actions/get';

export function request(dispatch) {
    api.get('/permissions').then(
        data => dispatch(finish(data)),
        errors => dispatch(error(data))
    );
}
